module.exports = __webpack_public_path__ + "assets/img/lecturer_no_avatar_white.svg";